import { cn } from '../../lib/utils';

export function SkeletonCard({ className }) {
  return (
    <div className={cn('rounded-lg border bg-card p-5 space-y-3', className)} data-testid="skeleton-card">
      <div className="h-4 w-1/3 rounded bg-muted animate-shimmer" />
      <div className="h-3 w-full rounded bg-muted animate-shimmer" />
      <div className="h-3 w-2/3 rounded bg-muted animate-shimmer" />
    </div>
  );
}

export function SkeletonRow({ cols = 4, className }) {
  return (
    <div className={cn('flex items-center gap-4 py-3 px-4', className)} data-testid="skeleton-row">
      {Array.from({ length: cols }).map((_, i) => (
        <div key={`skel-col-${i}`} className="h-3 flex-1 rounded bg-muted animate-shimmer" />
      ))}
    </div>
  );
}
